module.exports = __webpack_public_path__ + "static/media/back.03725237.svg";